export const loadAgentLinksPeriodMilliseconds: number = 1 * 20 * 60 * 1000
